import { render, staticRenderFns } from "./DesktopNavigation.vue?vue&type=template&id=7445fa92&scoped=true&"
import script from "./DesktopNavigation.vue?vue&type=script&lang=js&"
export * from "./DesktopNavigation.vue?vue&type=script&lang=js&"
import style0 from "./DesktopNavigation.vue?vue&type=style&index=0&id=7445fa92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7445fa92",
  null
  
)

export default component.exports